import { render, staticRenderFns } from "./InputInboxSubmission.vue?vue&type=template&id=5b83c825&scoped=true&"
import script from "./InputInboxSubmission.vue?vue&type=script&lang=js&"
export * from "./InputInboxSubmission.vue?vue&type=script&lang=js&"
import style0 from "./InputInboxSubmission.vue?vue&type=style&index=0&id=5b83c825&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83c825",
  null
  
)

export default component.exports